<div bsMigration [bs4Class]="['mb-3']" class="panel" formGroupName="recaptcha">
  <re-captcha formControlName="gRecaptchaResponse" [siteKey]="settings.recaptcha_site_key"></re-captcha>
</div>
